/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-03-02 09:37:30
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-08-24 15:46:32
 * @FilePath: \baishu_react_ui\src\components\BsyScroll\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import React, { Component } from "react";
import "./index.css";
import BsyCheckBox from "../BsyCheckBox";
import BsySLoading from "../BsySLoading";
import { BsyUtils } from "../../utils/Utils";

export const getParentPath = (parentPath) => {
  return parentPath.length ? `(${[...parentPath].reverse().join("/")})` : "";
};
export default class BsyTree extends Component {
  constructor(props) {
    super(props);
    this.state = {
      treeRootNode: props.treeRootNode,
      treeParentNode: props.treeParentNode,
      treeNode: props.treeNode,
      treeTitle: props.treeTitle,
      filter: props.filter,
      multi: props.multi || false, // 是否多选
      openNodes: props.openNodes || [props.treeRootNode],
      lastNodeSelect: true, // 是否选择最后一级节点
      onSelectData: props.onSelectData,
      nowNode: props.treeRootNode || "root",
      loading: true,
      mode: props.mode || null, // 组件所在的位置
      nodes: [],
      value: [],
    };
    this.input = React.createRef();
    this.nodeData = {}; // 所有节点数据
  }

  componentDidMount = () => {
    this.props?.getContext?.(this);
    const { nowNode } = this.state;
    this.loadData({
      nodeId: nowNode,
      parentNodeId: null,
    });
  };

  containsAllElements = (A) => {
    const { value } = this.state;
    const lastNode = A.filter(
      (element) => !element.children || element.children.length === 0
    );

    const ret = lastNode.filter((element) => value.includes(element.key));
    if (ret.length === lastNode.length) {
      return "all";
    }
    if (ret.length === 0) {
      return "none";
    }
    return "section";
  };

  renderChildren = (children, level) => {
    return (
      <div className="node-children">
        {children.map((it, index) => {
          return this.renderNode(
            it,
            level + 1,
            false,
            index === children.length - 1
          );
        })}
      </div>
    );
  };

  loadData = (node) => {
    if (this.props.onGetData) {
      this.props.onGetData(node, (data, search) => {
        if (!BsyUtils.isObjectEmpty(data)) {
          this.nodeData[node.nodeId] = {
            ...(this.nodeData[data.key] ? this.nodeData[data.key] : {}),
            ...data,
          };
          this.nodeData[node.nodeId].isRead = true;
          if (data.children) {
            data.children.map((it) => {
              this.nodeData[it.key] = { ...it, parent: data.key };
            });
          }
          // const nodes = this.expandNode(this.nodeData["root"], 0);
          // console.log(nodes);
        }
        this.setState({
          loading: false,
        });
      });
    }
  };

  setValue = (val, isDel) => {
    const { value } = this.state;
    const { onChangeData } = this.props;
    if (isDel) {
      this.setState(
        {
          value: value.filter((it) => {
            return it !== val;
          }),
        },
        () => {
          onChangeData?.(this.state.value, val, isDel);
          // console.log("setValue", this.state.value);
        }
      );
    } else {
      this.setState({ value: [...value, val] }, () => {
        // console.log("setValue", this.state.value);
        onChangeData?.(this.state.value, val, isDel);
      });
    }
  };
  _getCheckData = () => {
    return this.getValue();
  };

  getValue = () => {
    const { value } = this.state;
    return value.map((it) => {
      return this.nodeData[it].data;
    });
  };

  setExpandNode = (key, parent) => {
    const { openNodes } = this.state;

    // const nextNodes = this.childrenNodes(this.nodeData[key]);
    // console.log("nextNodes", nextNodes);

    const index = openNodes.indexOf(key);
    if (index > -1) {
      this.setState({
        openNodes: openNodes.filter((it) => {
          return it !== key;
        }),
      });
    } else {
      if (this.nodeData[key]?.isRead) {
        this.setState({
          openNodes: [...openNodes, key],
        });
      } else {
        this.setState(
          {
            nowNode: key,
            openNodes: [...openNodes, key],
            loading: true,
          },
          () => {
            this.loadData({
              nodeId: key,
              parentNodeId: parent,
            });
          }
        );
      }
    }
  };

  // 用当前节点，获取上级最后一个节点，主要用于处理引导线是否显示的问题
  getParentNodeEndChild = (node, level) => {
    if (!node) {
      return true;
    }
    const getParentNode = (nowNode) => {
      if (!nowNode) {
        return null;
      }
      return this.nodeData[nowNode.parent];
    };

    let parent = node;
    let nowNode = node;

    for (let index = 0; index < level; index++) {
      parent = getParentNode(nowNode);
      if (!parent) {
        return true;
      }
      if (index < level - 1) nowNode = parent;
    }
    if (BsyUtils.isObjectEmpty(parent.children)) {
      return true;
    }
    return parent.children[parent.children.length - 1]?.key === nowNode.key;
  };

  setPlaceholder = (level, node, end, loading) => {
    let att = new Array(level);
    att.fill("-");

    if (!node) {
      return att.map((it, index) => {
        return (
          <span className="placeholder">
            <div className="left">
              <div className={"middle-line"}></div>
            </div>
          </span>
        );
      });
    }

    return att.map((it, index) => {
      if (index === att.length - 1) {
        if (end) {
          if (loading) {
            return "";
          }
          return (
            <span className={`placeholder  `}>
              <div className="left">
                <div className={"middle-line-half"}></div>
              </div>
              <div className="right"></div>
            </span>
          );
        }

        return (
          <span className={`placeholder  `}>
            <div className="left">
              <div className={"middle-line"}></div>
            </div>
            <div className="right"></div>
          </span>
        );
      }
      let ret = this.getParentNodeEndChild(node, level - index);
      if (ret) {
        return <span className="placeholder"></span>;
      }

      return (
        <span className="placeholder">
          <div className="left">
            <div className={"middle-line"}></div>
          </div>
        </span>
      );
    });
  };

  renderNodeTitle = (children, node, isRoot, level, isend) => {
    const { lastNodeSelect, multi, value, openNodes, mode } = this.state;

    const stateIcon = openNodes.includes(node.key)
      ? "icon-bsy-folder-open"
      : "icon-bsy-folder-close";

    const nstf = this.containsAllElements(children || []);
    // 检查下级节点中，是否有末尾节点
    const hasLastNode = (children || []).find((it) => {
      return BsyUtils.isObjectEmpty(it.children);
    });
    return (
      <div
        key={node.key}
        className={`node-title ${
          children && children.length ? "" : "last-node"
        }`}
        onClick={(e) => {
          if (node.key === "root") {
            return;
          }

          if (!BsyUtils.isObjectEmpty(node.children)) {
            return;
          }

          if (multi) {
            this.setValue(node.key, this.state.value.includes(node.key));
            return;
          }

          this.props.onSelectData(node.data);
        }}
      >
        {!isRoot && this.setPlaceholder(level, node, isend)}

        {children && children.length ? (
          <>
            {multi && hasLastNode && node.isRead ? (
              <i
                className={`children-check ${
                  nstf === "all"
                    ? "icon-bsy-select"
                    : nstf === "none"
                    ? "icon-bsy-check2"
                    : "icon-bsy-part"
                }`}
                onClick={(e) => {
                  // console.log("onClick", nstf, e);
                  if (!node.isRead) {
                    return;
                  }
                  const lastNodes = children
                    .map((element) =>
                      !element.children || element.children.length === 0
                        ? element.key
                        : null
                    )
                    .filter((it) => it);

                  if (nstf === "all") {
                    const newNode = this.state.value.filter(
                      (element) => !lastNodes.includes(element)
                    );
                    this.setState(
                      {
                        value: newNode,
                      },
                      () => {
                        this.props.onChangeData?.(
                          this.state.value,
                          lastNodes,
                          true
                        );
                      }
                    );
                    // setValue(newNode);
                    // onSelectRows?.(getValue(newNode));
                  } else {
                    const nodeT = BsyUtils.arrayUnique([
                      ...this.state.value,
                      ...lastNodes,
                    ]);
                    this.setState(
                      {
                        value: nodeT,
                      },
                      () => {
                        this.props.onChangeData?.(this.state.value);
                      }
                    );
                    // setValue(nodeT);
                    // onSelectRows?.(getValue(nodeT));
                  }
                  // setExp(node.key, isRoot ? null : node.parent);
                }}
              />
            ) : (
              ""
            )}
            <i
              className={`icon ${stateIcon}`}
              onClick={(e) => {
                this.setExpandNode(node.key, isRoot ? null : node.parent);
              }}
            ></i>
          </>
        ) : (
          ""
        )}
        {!lastNodeSelect ? (
          multi ? (
            <BsyCheckBox
              key={BsyUtils.getRandomCode(10)}
              text=""
              value={value.includes(node.key)}
              onChange={(e) => {
                this.setValue(node.key, !e);
              }}
            />
          ) : (
            ""
          )
        ) : !children || children.length === 0 ? (
          multi ? (
            <BsyCheckBox
              key={BsyUtils.getRandomCode(10)}
              text=""
              value={value.includes(node.key)}
              onChange={(e) => {
                this.setValue(node.key, !e);
              }}
            />
          ) : (
            ""
          )
        ) : (
          ""
        )}

        <span className="node-title-text">
          {node.title}
          {isRoot && mode === "seach" ? (
            <span className="parent-path">
              {getParentPath(node.parent_path || [])}
            </span>
          ) : (
            ""
          )}
        </span>
      </div>
    );
  };

  renderBody = (children, node, level, isend) => {
    const { nowNode, loading } = this.state;
    return (
      <>
        {nowNode === node.key && loading ? (
          <div
            key={node.key}
            className="node-title"
            style={{
              position: "relative",
            }}
          >
            {this.setPlaceholder(level, node, isend, loading)}
            <BsySLoading
              mode={"dotLoading"}
              style={{
                width: 40,
                left: level * 26 + 6,
              }}
            ></BsySLoading>
          </div>
        ) : children && children.length ? (
          this.renderChildren(children, level)
        ) : (
          ""
        )}
      </>
    );
  };

  renderNode = (node, level, isRoot = false, isend = false) => {
    const { openNodes } = this.state;

    const nodeInfo = this.nodeData[node.key];
    const children = nodeInfo?.children;
    if (!nodeInfo) {
      return "";
    }

    const state = openNodes.includes(nodeInfo.key) ? "open" : "close";

    return (
      <div
        className={`bsy-tree-node node-${nodeInfo.key} ${state} node-level-${level}`}
        key={nodeInfo.key}
      >
        {this.renderNodeTitle(children, nodeInfo, isRoot, level, isend)}
        {this.renderBody(children, nodeInfo, level, isend)}
      </div>
    );
  };

  render() {
    const { style } = this.props;
    const { treeRootNode, nowNode, loading } = this.state;
    return (
      <div className="bsy-tree" ref={this.input} style={{ ...style }}>
        {nowNode === treeRootNode && loading ? (
          <BsySLoading mode={"skeletonspin"}></BsySLoading>
        ) : (
          this.renderNode({ key: treeRootNode }, 0, true)
        )}
      </div>
    );
  }
}
